import React from 'react';

import './stubMatchRow.scss';

const StubMatchRow: React.FC = () => <div styleName="container" />;

export default StubMatchRow;
